export default __webpack_public_path__ + "menu-translation-icon.1f4f2cdd758b1701a387a06002fd0d90.svg";